import React, { useEffect, useState } from "react";
import SearchInput from "../SearchInput";
import { AnimatedTooltip } from "../AnimatedTooltip";
import { ArrowLeftCircleIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { MainNavbar } from "./MainNavbar";
import Spin from "../Spin";
import { cn } from "../../lib/utils";
import MainSidebar from "./MainSidebar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "../ui/sidebar";

const MainBody = ({
  children,
  actionContent,
  search = true,
  expandList = false,
  innerBody = false,
  searchParamData,
  handleClearSearch,
  handleSearchChange,
  loading,
  actionRight = false,
  actionAlign = "",
  parentHeight = false,
  className = "",
  mainClassName = "",
  mainTitle = "",
  actionContentDirect = "",
}) => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const formatTitle = () => {
    let words = title
      ? title?.split("/")?.pop()?.replace(/-/g, " ")?.split(" ")
      : [];
    return (
      words &&
      words
        .map((word) => {
          if (word) {
            return word[0].toUpperCase() + word.substring(1);
          } else {
            return "";
          }
        })
        .join(" ")
    );
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setTitle(window?.location?.pathname);
  });
  return !expandList && !innerBody ? (
    <SidebarProvider>
      <MainSidebar />
      <SidebarInset className={mainClassName}>
        <>
          {loading && <Spin full expand={parentHeight || expandList} />}
          {!expandList && !innerBody && (
            <div className="sticky top-0 z-40">
              <MainNavbar
                trigger={
                  <SidebarTrigger className="-ml-1 hover:cursor-pointer" />
                }
              />
              <div className="flex gap-2 h-9 items-center border-b bg-webPrimary px-4 z-[10] text-secondary-foreground selection:bg-white selection:text-webPrimary">
                <div className="hover:cursor-pointer text-white">
                  {/* <AnimatedTooltip title={"Back"} leftAlign={true}> */}
                  <ArrowLeftCircleIcon
                    size={16}
                    onClick={() => {
                      navigate(-1);
                    }}
                  />
                  {/* </AnimatedTooltip> */}
                </div>

                <h2 className="text-md text-white">
                  {mainTitle ? mainTitle : formatTitle()}
                </h2>
              </div>
            </div>
          )}

          <div
            className={cn(
              `${
                expandList
                  ? innerBody
                    ? "p-2"
                    : "p-4 px-3 bg-primary-foreground dark:bg-primary-foreground"
                  : innerBody
                  ? ""
                  : "min-h-mainNavScreen p-4"
              }`,
              className
            )}
          >
            <>
              {(search || actionContent) && (
                <div
                  className={`mb-3 flex-wrap gap-4 flex items-center w-full ${
                    actionRight ? "justify-end" : "justify-between"
                  }`}
                >
                  {search && (
                    <SearchInput
                      searchParamData={searchParamData}
                      handleClearSearch={handleClearSearch}
                      handleSearchChange={handleSearchChange}
                    />
                  )}
                  {actionContent && actionContentDirect ? (
                    <>{actionContent}</>
                  ) : (
                    actionContent && (
                      <div
                        className={`flex items-center gap-2 ${
                          actionAlign === "end"
                            ? "justify-end w-full"
                            : actionAlign === "center"
                            ? "justify-center w-full"
                            : actionAlign === "start"
                            ? "justify-start w-full"
                            : actionAlign === "between"
                            ? "justify-between w-full"
                            : ""
                        }`}
                      >
                        {actionContent}
                      </div>
                    )
                  )}
                </div>
              )}
              {children}
            </>
          </div>
        </>
      </SidebarInset>
    </SidebarProvider>
  ) : (
    <>
      {loading && <Spin full expand={parentHeight || expandList} />}
      {!expandList && !innerBody && (
        <div className="sticky top-0 z-40">
          <MainNavbar />
          <div className="flex gap-2 h-9 items-center border-b bg-webPrimary px-4 z-[10] text-secondary-foreground selection:bg-white selection:text-webPrimary">
            <div className="hover:cursor-pointer text-white">
              <AnimatedTooltip title={"Back"} leftAlign={true}>
                <ArrowLeftCircleIcon
                  size={16}
                  onClick={() => {
                    navigate(-1);
                  }}
                />
              </AnimatedTooltip>
            </div>

            <h2 className="text-md text-white">{formatTitle()}</h2>
          </div>
        </div>
      )}

      <div
        className={cn(
          `${
            expandList
              ? innerBody
                ? "p-2"
                : "p-4 px-3 bg-muted  dark:bg-primary-foreground"
              : innerBody
              ? ""
              : "min-h-mainNavScreen p-4"
          }`,
          className
        )}
      >
        <>
          {(search || actionContent) && (
            <div
              className={`mb-3 flex-wrap gap-4 flex items-center ${
                actionRight ? "justify-end" : "justify-between"
              }`}
            >
              {search && (
                <SearchInput
                  searchParamData={searchParamData}
                  handleClearSearch={handleClearSearch}
                  handleSearchChange={handleSearchChange}
                />
              )}
              {actionContent && (
                <div
                  className={`flex items-center gap-2 ${
                    actionAlign === "end"
                      ? "justify-end w-full"
                      : actionAlign === "center"
                      ? "justify-center w-full"
                      : actionAlign === "start"
                      ? "justify-start w-full"
                      : actionAlign === "between"
                      ? "justify-between w-full"
                      : ""
                  }`}
                >
                  {actionContent}
                </div>
              )}
            </div>
          )}
          {children}
        </>
      </div>
    </>
  );
};

export default MainBody;
